<template>
        <div class="product-placeholder">
          <aside ref="infoBox" class="information-box">
            <ProductBenefitsComponent
              :benefits="radio.benefits"
              :benefits-width="radio.benefitsWidth"
            />
            <ProductSpecificationsComponent
              :specifications="radio.specifications"
            />
          </aside>
          <div ref="mainPlaceholder" class="main-placeholder">
            <transition
              appear
              name="expandfade"
              @after-leave="resizeProduct"
              @after-enter="resizeProduct"
            >
            </transition>
            <transition name="implodefade">
              <div v-if="ifColorCode && radio.hasOwnProperty('colorCodeImagePath') && radio.colorCodeImagePath" class="mini-landscape-placeholder">
                <ColorCode
                  :section="prefix"
                  :color-code-image-path="radio.colorCodeImagePath"
                  :radio="radio"
                  :isPreview="isPreview"
                  class="mini-landscape-colorCode-add-on"
                />
              </div>
            </transition>
            <div ref="productPlaceholder" class="product-image-placeholder">
              <RotatingProduct
                v-if="radio.hasOwnProperty('modelFileName') && radio.modelFileName"
                ref="rotatingRef"
                class="thescene"
                :prefix="prefix"
                :stop="stop"
                :radio-name="radio.modelFileName"
                :radio="radio"
                :isPreview="isPreview"
              />
            </div>
          </div>
          <div class="restore-ico single-product-view-icons" @click="restore()">
            <img src="@/assets/eds-icons/restore.svg" />
          </div>
        </div>
</template>

<script>
import ColorCode from '@/components/colorCodeImage.vue';
import RotatingProduct from '@/components/rotatingProduct.vue';

import ProductBenefitsComponent from '@/components/ProductBenefitsComponent.vue';
import ProductSpecificationsComponent from '@/components/ProductSpecificationsComponent.vue';
import { FAMILY_PREVIEW_EDITOR_CONFIG as CONFIG } from '@/constants/familyPreviewEditor'; 

export default {
  name: 'ProductInformationComponent',
  components: {
    ProductBenefitsComponent,
    ProductSpecificationsComponent,
    RotatingProduct,
    ColorCode,
  },
  props: {
    section: Object,
    radio: Object,
    prefix: String,
    isPreview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      stop: false,
      ifColorCode: false
    };
  },
  beforeMount() {
    this.specialViewToggler(); //if there are any specialized views with special config
  },

  destroyed() {
    window.removeEventListener('resize', this.handleOverflow);
  },
  mounted() {
    // let rect = this.$refs.bottomPlaceholder.getBoundingClientRect();
    // this.$refs.mainPlaceholder.style.marginBottom = rect.height / 5 + "px";
    this.handleOverflow();
    window.addEventListener('resize', this.handleOverflow);
  },
  methods: {
    specialViewToggler() {
      this.ifColorCode = !this.ifColorCode;
    },
    resizeProduct() {
      if (this.section.name !== CONFIG.defaultFamilyName)
        this.$refs.rotatingRef.resizer();
    },
    handleOverflow() {
      let overflow = this.checkOverflow(this.$refs.infoBox);
      if (overflow) {
        /* Do not want the view the to overflow top and bottom if screen too big. */
        this.$refs.infoBox.style.justifyContent = 'space-between';
      } else {
        this.$refs.infoBox.style.justifyContent = 'space-around';
      }
    },
    checkOverflow(el) {
      var curOverflow = el.style.overflow;
      //if ( !curOverflow || curOverflow === "visible" )
      el.style.overflow = 'hidden';
      var isOverflowing =
        el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;
      el.style.overflow = curOverflow;

      return isOverflowing;
    },
    restore() {
      this.stop = !this.stop;
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../assets/common.less';

/* TRANSITIONS */
.fade2-enter-active,
.fade2-leave-active {
  transition: opacity 0.5s;
}
.fade2-enter, .fade2-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.expandfade-enter-active {
  animation: grow 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;
}
.expandfade-leave-active {
  animation: shrink 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;
}

.implodefade-leave-active {
  animation: gone 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;
}
.implodefade-enter-active {
  animation: appear 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;
}
/* ANIMATIONS */
@keyframes grow {
  0% {
    width: 0%;
    opacity: 0;
  }
  100% {
    width: 30%;
    opacity: 1;
  }
}

@keyframes shrink {
  to {
    width: 0%;
    opacity: 0;
  }
}

@keyframes appear {
  0% {
    width: 0%;
    opacity: 0;
  }
  70% {
    opacity: 1;
  }
  100% {
    width: 30%;
    opacity: 1;
  }
}

@keyframes gone {
  0% {
    width: 30%;
    opacity: 1;
  }
  30% {
    opacity: 0;
  }
  100% {
    opacity: 0;
    width: 0%;
  }
}

.thescene {
  touch-action: pinch-zoom;
}

.main-placeholder {
  display: flex;
  flex: 2;
  flex-direction: row;
  justify-content: center;

  .product-image-placeholder {
    flex: 2;
    min-width: 50%;
    transition: all 1.5s ease;
    margin: 0 0 @space-4xl @space-small;
    max-width: 68%;
  }

  .mini-landscape-placeholder {
    z-index: 0;
    display: flex;
    position: relative;
    width: 30%;
    overflow: hidden;
  }
}

.product-placeholder {
  width: 100%;
  height: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex: 1;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  padding-bottom: 46 / @px;
  .restore-ico {
    position: fixed;
    width: @font-size-xl;
    height: @font-size-xl;
    bottom: 8%;
    right: 2%;
    display: inline-block;
    cursor: pointer;
  }
  .information-box {
    flex: 1;
    padding: @space-base @space-large 0 @space-xl;
    overflow-y: auto;
    min-width: 10rem;
    height: 87%;
    font-size: 1rem;
    flex-direction: column;
    justify-content: flex-start;
    margin: 0px;
  }
}

/* Aside-box */

.mini-landscape-placeholder {
  margin-bottom: 3.75rem;
}

.mini-landscape {
  position: relative;
  height: 65vh;
  width: 100%;
  background-color: transparent;
  transition: all 1s ease-in-out;
}
.mini-landscape-colorCode-add-on {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  user-select: none;
}
@media only screen and (max-width: 950px) {
  .mini-landscape-placeholder {
    overflow: hidden;
  }
}

/* GENERAL */

.p-tag {
  margin: 0px;
}
</style>
